import React from "react";
import "./Footer.css";

function Footer() {
    return(
        <footer className="footer">
            <p className="footer__text">&#169; Сайт создан для добавления в портфолио и не является коммерческим предприятием.</p>
        </footer>
    )
}

export default Footer;
